import axios from 'axios'
import * as utils from 'src/apis/apiUtils'

export default {
  index(params) {
    return axios.get(utils.getApiUrl('/masters/shinshukutsugite'), {
      params: params || {}
    })
  },
  getZaishitsuList(params) {
    return axios.get(utils.getApiUrl('/masters/shinshukutsugite/get_zaishitsu_list'), {
      params: params || {}
    })
  },
  create({ data }) {
    return axios.post(utils.getApiUrl('/masters/shinshukutsugite'), data)
  },
  update({ id, data }) {
    return axios.put(utils.getApiUrl(`/masters/shinshukutsugite/${id}`), data)
  },
}
